<template>
  <div class="callback-container">
    <div class="callback-box">
      <b-spinner v-if="loading" label="加载中..."></b-spinner>
      <div v-else>
        <h3>{{ message }}</h3>
        <p v-if="error">{{ errorMsg }}</p>
        <b-button v-if="error" @click="goToLogin" variant="primary">返回登录</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data() {
    return {
      loading: true,
      message: '微信登录处理中...',
      error: false,
      errorMsg: ''
    }
  },
  methods: {
    goToLogin() {
      this.$router.push('/login');
    },
    
    processWxLogin(code) {
      // 判断当前平台
      const isWeChat = /micromessenger/i.test(navigator.userAgent.toLowerCase())
      const isMobile = /android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase())
      const platform = isWeChat ? 'mp' : (isMobile ? 'mobile_web' : 'pc_web')
      // 调用后端微信登录回调接口，后端会根据code换取token并返回用户信息
      axios.get('https://api.zizizaizai.com/v2/login/wx/callback', { params: { code, platform } })
        .then(res => {
          const data = res && res.data ? res.data : {}
          if (data.code === 20000 && data.data) {
            this.message = '登录成功，正在跳转...';

            // 存储令牌与用户信息
            try {
              const accessToken = data.data.access_token
              const refreshToken = data.data.refresh_token
              const userInfo = data.data.user_info
              if (accessToken) localStorage.setItem('token', accessToken)
              if (refreshToken) localStorage.setItem('refresh_token', refreshToken)
              if (userInfo) localStorage.setItem('user_info', JSON.stringify(userInfo))
              // 广播登录事件，方便其他组件响应
              try { window.dispatchEvent(new CustomEvent('user-login', { detail: { userInfo } })) } catch (e) { console.warn('dispatch user-login failed') }
            } catch (e) {
              console.warn('保存登录信息失败', e)
            }

            // 处理state中的来源页重定向（如果存在）
            let redirect = '/'
            try {
              const state = this.$route.query.state
              if (state) {
                const decoded = decodeURIComponent(state)
                if (decoded && decoded.startsWith('/')) redirect = decoded
              }
            } catch (e) { console.warn('decode state failed') }

            setTimeout(() => {
              this.$router.replace(redirect)
            }, 800)
          } else {
            this.error = true;
            this.message = '登录失败';
            this.errorMsg = data.message || '微信登录处理失败';
          }
        })
        .catch(err => {
          console.error('微信登录错误:', err);
          this.error = true;
          this.message = '登录失败';
          this.errorMsg = (err && err.response && err.response.data && err.response.data.message)
            ? err.response.data.message
            : '微信登录处理出错，请稍后重试';
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  mounted() {
    // 获取URL中的code参数
    const code = this.$route.query.code;
    
    if (code) {
      this.processWxLogin(code);
    } else {
      this.loading = false;
      this.error = true;
      this.message = '登录失败';
      this.errorMsg = '未获取到微信授权码';
    }
  }
}
</script>

<style scoped>
.callback-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f5f5f5;
}

.callback-box {
  width: 400px;
  padding: 30px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
}

h3 {
  margin-bottom: 20px;
}

p {
  color: #f56c6c;
  margin-bottom: 20px;
}
</style>
